import React, { useRef, lazy } from "react"
import TabContent from "@/components/PressRoomLanding/v1/TabContent"
import TabComponent from "@/components/PressRoomLanding/v1/TabComponent"

const PressRelease = lazy(() =>
  import("@/components/PressRoomLanding/v1/PressRelease.view")
)
import styles from "@/components/PressRoomLanding/v1/PressRoomView/index.module.scss"
import PressKitView from "@/components/PressRoomLanding/v1/PressKit.view"

const PressRoomView = ({
  i18n = {},
  pressContact = [],
  title = "",
  desc = "",
  productPlacement = [],
  imageLibraryLink = "",
}) => {
    const activeTabData = useRef(null)
    const sanitizeText = text => {
    if (!text) return ""
    return text
      ?.replace(/<[^>]*>/g, "") // Remove HTML tags
      ?.replace(/&amp;/g, "&") // Convert &amp; to &
      ?.replace(/&lt;/g, "<") // Convert &lt; to <
      ?.replace(/&gt;/g, ">") // Convert &gt; to >
      ?.replace(/&quot;/g, '"') // Convert &quot; to "
      ?.replace(/&#039;/g, "'") // Convert &#039; to '
      ?.replace(/&#39;/g, "'") // Convert &#39; to '
      ?.trim()
  }
  
  const tabList = [
    {
      title: i18n.pressRelease,
      content: (
        <TabContent
          analyticsLabel="press releases"
          i18n={i18n}
          pressContact={pressContact}
          productPlacement={productPlacement}
          tabData={<PressRelease i18n={i18n} refData={activeTabData} />}
        />
      ),
    },
    {
      title: i18n.pressKit,
      content: (
        <TabContent
          analyticsLabel="press kits"
          i18n={i18n}
          pressContact={pressContact}
          productPlacement={productPlacement}
          tabData={<PressKitView i18n={i18n} refData={activeTabData} />}
        />
      ),
    },
    {
      title: i18n.imageLibrary,
      url: imageLibraryLink,
    },
  ]
  return (
    <div className={styles.myRoomViewWrapper} id="press-room-as">
      <main tabIndex="-1" className="press-room">
        {/* hero-banner */}
        <div className="container-fluid press-room__header">
          <div className="kf-react-container">
            <div className="row press-room__main-row">
              <div className="col-8 col-md-8 press-room__title-block">
                <h1 className="press-room__title">{title}</h1>
              </div>
              <div className="col-4 col-md-4 press-room__description-block">
                <p className="press-room__description">{sanitizeText(desc)}</p>
              </div>
            </div>
          </div>
        </div>
        <TabComponent i18n={i18n} tabList={tabList} refData={activeTabData} />
      </main>
    </div>
  )
}

export default PressRoomView
